import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class PackagesHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getAllFiles(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_files_list';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getAllUIFiles(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_ui_list';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getBundleSpec(queryParams: any): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_bundle_spec';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getAvailableVersions(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_avail_vers';
			const params = {
				response: false
			};
			API.get(this.apiName, path, params).then(resu => {
				let lists = resu.data;
				const verArray = [];
				for (const list of lists) {
					verArray.push(list.file_version);
				}
				observer.next(verArray);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getInCompVersions(comp): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/incompatibles';
			const params = {
				body: {
					comp
				}
			};
			API.post(this.apiName, path, params).then(lists => {
				const verArray = [];
				for (const list of lists) {
					verArray.push(list.file_version);
				}
				observer.next(verArray);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	assignBundleSpec(assignObj): Observable<string> {
		return new Observable((observer: any) => {
			const path = '/dashboard/assignBundle';
			const params = {
				body: assignObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	delBundleSpec(assignObj): Observable<string> {
		return new Observable((observer: any) => {
			const path = '/dashboard/removeBundle';
			const params = {
				body: assignObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	cloudEdit(editedFile): Observable<string> {
		return new Observable((observer: any) => {
			const path = '/dashboard/cloudFileEdit';
			const params = {
				body: editedFile
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	cloudDelete(obj): Observable<string> {
		return new Observable((observer: any) => {
			const path = '/dashboard/cloud_delete';
			const params = {
				body: obj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getS3Obj(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_up_obj';
			const params = {
				response: false
			};
			API.get(this.apiName, path, params).then(obj => {
				observer.next(obj);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	cloudUploads(upObj): Observable<string> {
		return new Observable((observer: any) => {
			const path = '/dashboard/cloudUpload';
			const params = {
				body: upObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
